import { CalendarItemType } from '../../api/api-types/calendar';
import { computed, makeAutoObservable } from 'mobx';

export class CalendarItem implements CalendarItemType {
  readonly id: CalendarItemType['id'];
  readonly assetDate: CalendarItemType['assetDate'];
  readonly type: CalendarItemType['type'];
  readonly priority: CalendarItemType['priority'];
  readonly status: CalendarItemType['status'];
  readonly isRelatedEntityActive: CalendarItemType['isRelatedEntityActive'];

  constructor(item: CalendarItemType) {
    makeAutoObservable(this);
    this.id = item.id;
    this.assetDate = item.assetDate;
    this.type = item.type;
    this.priority = item.priority;
    this.status = item.status;
    this.isRelatedEntityActive = item.isRelatedEntityActive;
  }

  private parseDate() {
    if (!this.assetDate)
      return {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        day: new Date().getDate(),
      };

    const [year, month, day] = String(this.assetDate).split('-').map(Number);

    return {
      year,
      month,
      day,
    };
  }

  @computed get startDate() {
    return new Date(
      this.parseDate().year,
      this.parseDate().month - 1,
      this.parseDate().day,
      0,
      1,
    );
  }

  @computed get endDate() {
    return new Date(
      this.parseDate().year,
      this.parseDate().month - 1,
      this.parseDate().day,
      23,
      0,
    );
  }
}
